<div class="left-nav-chat-wrapper">
    <epd-button
        epdTooltip
        epdTooltipTitle="New Conversation"
        epdTooltipPlacement="right"
        label="Start a New Conversation"
        class="chat-button"
        size="large"
        (click)="startNewConversation()"
    ></epd-button>

    <!--hidden due to the AC of US634746-->
    @if (false) {
        <div class="discovery-container">
            <epd-select #dropdownComponent>
                @for (discoveryOption of discoveryOptions; track discoveryOption.id) {
                    <epd-option
                        [value]="discoveryOption.id"
                        [label]="discoveryOption.label"
                        [disabled]="true"
                    ></epd-option>
                }
            </epd-select>

            <div
                class="discovery-button body-md-16-semibold"
                [ngClass]="{ focused: isDiscoveryDropdownOpened }"
                (click)="onDiscoveryDropdownClick($event)"
            >
                <span>Discovery (Coming Soon)</span>
                <epd-icon
                    class="dropdown-icon"
                    [size]="'medium'"
                    [type]="isDiscoveryDropdownOpened ? 'chevron-up' : 'chevron-down'"
                />
            </div>
        </div>
    }

    <epd-button
        label="Research Agent Overview"
        class="craig-demo-button"
        size="large"
        (click)="goToDemo()"
    ></epd-button>

    <epd-button label="Provide Feedback" class="provide-feedback-button" size="large" (click)="provideCraigFeedback()">
    </epd-button>
    <craig-streaming-conversation-history></craig-streaming-conversation-history>
</div>
<div class="introduction-link-container">
    <span class="accuris-logo"></span>
    <span class="introduction-link-title body-sm-14-regular" (click)="showIntroductionPanel()">Introduction</span>
</div>
